<template>
    <div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-3 text-left" style="padding-right: 0px;">
                    <label class="text-left">{{$Jed.firstUpperTranslate("address", 2)}}: {{$Jed.firstUpperTranslate("row") + ' ' + currentRow + ' ' + $Jed.translate("of") + ' ' + maxRows}}</label>
                </div>
                <div class="col-md-1 text-left" style="padding-left: 0px;">
                    <a style="cursor: pointer;" @click.prevent="addAddressClick">
                        <i :class="$root.icons.plus" style="font-size: 1.8em;" aria-hidden="true"></i>
                    </a>
                </div>
            </div>
            <div class="row">
                <div class="col-md">
                    <div class="form-group">
                        <div style="padding: 5px;">       
                            <grid :others="others" :columns="otherAddressAttributesCfg.columns"
                                :source.sync="addressList" :options="options"
                                    :lang="$root.token.idLingua" :name="otherAddressAttributesCfg.title" :rowClick="rowClicked"> 
                            </grid>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-7"></div> <!--<div class="col-md-3"></div>-->
                <div class="col-md-5"> <!--<div class="col-md-9">-->
                    <!--<div class="controls col-sm-4">
                        <button class="btn btn-primary-default" @click.prevent="addaddressClick" style="width: 100%">{{otherAddressLabels.addAddressBtnLbl}}</button>
                    </div>-->
                    <div class="controls col-sm-6"> <!--<div class="controls col-sm-4">-->
                        <button class="btn btn-danger" @click.prevent="cancelClick" style="width: 100%">{{otherAddressLabels.annullaBtnLbl}}</button>
                    </div>
                    <div class="controls col-sm-6"> <!--<div class="controls col-sm-4">-->
                        <button class="btn btn-primary-default" @click.prevent="confirmClick" style="width: 100%">{{otherAddressLabels.confermaBtnLbl}}</button>
                    </div>
                </div>
            </div>
        </div>  
    </div>   
</template>

<script>

import { eventBus } from "../../../eventbus";
import Grid from '../../dynamic/jqwGridWrapper/jqwGridWrapper.vue'

export default {
    components: {
        Grid
    },
    props:{
        addressList: Array
    },
    watch:{
        addressList: function(){
            this.maxRows = this.addressList.length
            this.currentRow = 1
        }
    },
    data: function () {
        var vm = this;
        return {
            otherAddressLabels: {
                annullaBtnLbl: vm.$Jed.firstUpperTranslate("cancel"),
                confermaBtnLbl: vm.$Jed.firstUpperTranslate("confirm"),
                addAddressBtnLbl: vm.$Jed.firstUpperTranslate("add address"),
            },
            options: {
                columnsresize: true,
                columnsreorder: true,
                rowsheight: 26,
                theme: "light",
                width: "100%",
                selectionmode: "singlerow",
                pageable: true,
                showfilterrow: false,
                filterable: true,
                sortable: true,
                pageable: false,
                autoheight: false,
                height: 210,
                rowdetails: true,
                rowdetailstemplate: {
                    rowdetails:
                        "<div style='margin: 10px 10px 10px 0px;'>Override this</div>",
                    rowdetailsheight: 250 /* ! 230 + 20 ! */
                },
                /* configurando una griglia ricorsiva, impostare rowdetailstemplate.rowdetails height uguale all'altezza della griglia innestata ... 
                ... (in questo caso definita con autoheight: false e height: 230), + 20px per tenere in considerazione e margini di default */
                initrowdetails: "nested",
                rendered: null
            },
            others:{
                adaptColumns: true
            },
            otherAddressAttributesCfg: {
                ID: "otherAddrAttributesId",
                title: "TabellaIndirizzi",
                label_title: "",
                visible: true,
                columns: {
                    configs:{
                        del: {
                            text: '',
                            position: 1,
                            visible: true,
                            editable: false,
                            width: "2%",
                            datafield: "del",
                            iconcolumn: true,
                            geticonclass: function(data_row){
                                if(!data_row.pid){
                                    return vm.$root.icons.close
                                }
                            },
                            onclick: function(obj, ev, i) {
                                //posso eliminare gli indirizzi solo se sono stati inseriti da front-end (hanno pid - id provincia new nullo)
                                var ok = function(){
                                        vm.$emit("onDeleteAddressEvent", obj);
                                        this.close();
                                    },
                                    no = function(){
                                        this.close();
                                    },
                                    e = {
                                        message: vm.$Jed.firstUpperTranslate('selected address') + ': '+ obj.add + '<br>' + vm.$Jed.firstUpperTranslate('Do you want to delete it?'), 
                                        ok: ok,
                                        no: no
                                    }                                    
                                if(!obj.pid){ //se pid è nullo posso eliminare l'indirizzo
                                    eventBus.$emit("confirm", e) 
                                }
                            }
                        },
                        mod: {
                            text: '',
                            position: 2,
                            visible: true,
                            editable: false,
                            width: "2%",
                            datafield: "mod",
                            iconcolumn: true,
                            geticonclass: function(data_row){
                                if(!data_row.pid){
                                    return vm.$root.icons.edit
                                }
                            },
                            onclick: function(obj, ev, i) {
                                //posso modificare gli indirizzi solo se sono stati inseriti da front-end (hanno pid - id provincia new nullo)
                                if(!obj.pid){ //se pid è nullo posso modificare l'indirizzo
                                    vm.$emit("onOpenModifyAddressEvent", {obj:obj});
                                }
                            }
                        },
                        dest: {
                            text: vm.$Jed.firstUpperTranslate("recipient"),
                            position: 3,
                            visible: true,
                            editable: false,
                            width: "16%",
                            searchable: false,
                            sorting: true,
                            datafield: "con" 
                        },
                        indirizzo: {
                            text: vm.$Jed.firstUpperTranslate('address'),
                            position: 4,
                            visible: true,
                            editable: false,
                            width: "23%", 
                            searchable: false,
                            sorting: true,
                            datafield: "add"
                        },
                        cap: {
                            text: vm.$Jed.firstUpperTranslate('cap'),
                            position: 5,
                            visible: true,
                            editable: false,
                            width: "10%",
                            searchable: false,
                            sorting: true,
                            datafield: "cap"
                        },
                        loc: {
                            text: vm.$Jed.firstUpperTranslate("Localita"),
                            position: 6,
                            visible: true,
                            editable: false,
                            width: "11%",
                            searchable: false,
                            sorting: true,
                            datafield: "loc"
                        },
                        prov: {
                            text: vm.$Jed.firstUpperTranslate("province"),
                            position: 7,
                            visible: true,
                            editable: false,
                            width: "10%",
                            searchable: false,
                            sorting: true,
                            datafield: "pro"
                        },
                        reg: {
                            text: vm.$Jed.firstUpperTranslate("region"),
                            position: 7,
                            visible: true,
                            editable: false,
                            width: "12%",
                            searchable: false,
                            sorting: true,
                            datafield: "reg" 
                        },
                        naz: {
                            text: vm.$Jed.firstUpperTranslate("country"),
                            position: 7,
                            visible: true,
                            editable: false,
                            width: "10%",
                            searchable: false,
                            sorting: true,
                            datafield: "nat"
                        }
                    }
                }
            },
            currentRow: 1,
            maxRows: 1,
            clicked_obj: null
        }
    },
    methods: {
        cancelClick() {
            this.$emit("onCancelOtherAddressEvent");
        },
        confirmClick() {
            this.$emit("onConfirmOtherAddressEvent", this.clicked_obj);
        },
        addAddressClick(){
            this.$emit('onOpenAddAddressEvent');
        },
        rowClicked(obj, index){
            this.clicked_obj = obj
            this.currentRow = index+1;
        }
    }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/views/shopcart/OtherAddress.vue?81a10fb4